// The "Duration: 90 minutes" line under an event in the basket, or null.
//
// Events with no running time come from Rails with `duration: 0`. Guarding
// the line with `event.duration && ...` renders that 0 as text in React, so
// only a positive number of minutes gets a line.

const eventDurationText = event => {
  const minutes = Number(event?.duration)
  if (!Number.isFinite(minutes) || minutes <= 0) return null
  return `Duration: ${minutes} minutes`
}

module.exports = { eventDurationText }
